import { getCallingCodeForCountry } from "./phone-input-validator";
import { getI18nCountries } from "../../utils/getI18nCountries";
import { logger } from "../../utils/console";
let defaultLang = null;
export function getDefaultLanguage() {
    if (defaultLang === null) {
        try {
            // @ts-expect-error Check for typing
            defaultLang = document.getElementsByTagName("html")[0].getAttribute("lang").replace(/[-_]/g, "-").split("-")[0];
        }
        catch {
            defaultLang = "en";
            logger.warn("Could not get default language");
        }
    }
    return defaultLang;
}
/** List of countryCodes that should be displayed with the alias name instead of the official name */
const preferAliasCountries = ["TW"];
export async function getCountryDataProvider(lang) {
    if (lang === undefined || lang.length === 0) {
        lang = getDefaultLanguage();
    }
    const { countries } = await getI18nCountries(lang);
    return Object.keys(countries)
        .map((countryCode) => {
        const label = Array.isArray(countries[countryCode])
            ? (preferAliasCountries.includes(countryCode) && countries[countryCode][1]) || countries[countryCode][0]
            : countries[countryCode].toString();
        return {
            country: countryCode,
            label: label,
            prefix: getCallingCodeForCountry(countryCode)
        };
    })
        .filter(({ prefix }) => prefix !== "")
        .sort(sortCountries);
}
const sortCountries = (a, b) => {
    if (a.label < b.label) {
        return -1;
    }
    if (a.label > b.label) {
        return 1;
    }
    return 0;
};
//# sourceMappingURL=regions.js.map
